import { message } from "antd";
import { client } from "../../../../actions";
import { userActions } from "../../../../actions/user.actions";
import { authHeader } from "../../../../helpers/auth-header";
import actions from "../actions/actions";

const getMeterTypes = () => async (dispatch) => {
	try {
		dispatch({ type: actions.LIST_LOADING });
		const response = await client.get("/Meter/meter_types", {
			headers: authHeader(),
		});
		if (typeof response.data === "string" &&
			response.data.includes("AuthenticationFailed")) {
			message.error("Произошла ошибка авторизации");
			dispatch(userActions.logout());
			return;
		}
		dispatch({
			type: actions.METER_TYPES_LOADED,
			payload: response.data,
		});
	} catch (e) {
		console.log(e);
	}
};

export default getMeterTypes;
